import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function SolarReviews(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#25AFE8" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M10.4715 7.61662C10.8396 7.86663 11.1532 8.24163 11.3577 8.64442L10.5533 9.18609C10.4306 8.93609 10.2261 8.65831 10.0216 8.49164C9.84434 8.35275 9.51712 8.17219 8.99902 8.17219C8.09917 8.17219 7.472 8.74164 7.472 9.60276C7.472 9.96388 7.56744 10.1722 7.81285 10.4083C8.08553 10.6861 8.42639 10.8389 8.76724 10.9917L9.63982 11.3806C10.1716 11.6167 10.6624 11.8667 11.0441 12.2556C11.5077 12.7278 11.6986 13.2695 11.6986 13.9362C11.6986 15.6445 10.4579 16.7834 8.82178 16.7834C8.22188 16.7834 7.472 16.6584 6.84483 16.0334C6.3949 15.589 6.12222 14.9501 5.99951 14.3945L6.98117 14.1167C7.04934 14.6028 7.26749 15.0195 7.52653 15.2973C7.92192 15.7001 8.37185 15.8112 8.83541 15.8112C10.0761 15.8112 10.6624 14.9084 10.6624 13.9778C10.6624 13.5612 10.5397 13.2 10.2125 12.8945C9.95341 12.6445 9.59892 12.4778 9.12173 12.2556L8.30368 11.8667C8.27932 11.8552 8.25451 11.8436 8.22929 11.8319C7.88754 11.6723 7.47116 11.4779 7.09024 11.1028C6.69485 10.7139 6.46307 10.2833 6.46307 9.58888C6.46307 8.1583 7.54017 7.19995 9.01265 7.19995C9.57165 7.19995 10.0216 7.31106 10.4715 7.61662ZM14.196 7.19996H12.7371V16.464H13.746V12.4084H14.0051L16.7728 16.464H17.9999L15.1095 12.325C16.4865 12.2278 17.4 11.1861 17.4 9.76945C17.4 8.78332 16.9364 8.07498 16.4047 7.71386C15.723 7.24163 14.8095 7.19996 14.196 7.19996ZM13.7461 11.4917V8.17222H14.3596C14.7959 8.17222 15.2595 8.2 15.6685 8.43611C16.2412 8.76945 16.3911 9.28334 16.3911 9.79724C16.3911 10.8806 15.6413 11.4917 14.3869 11.4917H13.7461Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

SolarReviews.propTypes = propTypes;
SolarReviews.defaultProps = defaultProps;

export default SolarReviews;
